import React from "react";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import { ReactComponent as PendingClockIcon } from "../../../../../assets/vectors/pending_clock.svg";
import EmptyListIcon from "assets/vectors/infoModal/Universal_Payment.svg";
import constants from "constants/constants";

export const DISPUTE_HISTORY = "dispute-history";

export const DISPUTES_STATUSES = {
  dispute_raised: "Dispute Raised",
  dispute_document_uploaded: "Dispute Document Uploaded",
  dispute_resolved: "Dispute Resolved",
  dispute_lost: "Dispute Lost",
  dispute_reopened: "Dispute Reopened",
  dispute_accepted: "Dispute Accepted",
};

export const DISPUTE_STATUS_ENUM = {
  RAISED: 1,
  ACCEPTED: 2,
  DOCUMENTUPLOADED: 3,
  RESOLVED: 4,
  LOSTUNDERRECOVERY: 5,
  LOSTRECOVERED: 6,
  ARBITRATIONRAISED: 7,
};

export const GET_LIST_SORTING_CONSTANTS = {
  CREATED_AT: "created_at",
  DESC: "DESC",
};

export const DISPUTE_STATUS_MAP = {
  [DISPUTE_STATUS_ENUM.RAISED]: "RAISED",
  [DISPUTE_STATUS_ENUM.ACCEPTED]: "ACCEPTED",
  [DISPUTE_STATUS_ENUM.DOCUMENTUPLOADED]: "DOCUMENTS_UPLOADED",
  [DISPUTE_STATUS_ENUM.RESOLVED]: "WON_BY_EXLY",
  [DISPUTE_STATUS_ENUM.LOSTUNDERRECOVERY]: "LOST_UNDER_RECOVERY",
  [DISPUTE_STATUS_ENUM.LOSTRECOVERED]: "LOST_RECOVERED",
  [DISPUTE_STATUS_ENUM.ARBITRATIONRAISED]: "ARBITRATION_RAISED",
};

export const DISPUTE_STATUS_FILTER_OPTIONS = [
  {
    label: "Raised",
    value: DISPUTE_STATUS_ENUM.RAISED,
  },
  {
    label: "Accepted",
    value: DISPUTE_STATUS_ENUM.ACCEPTED,
  },
  {
    label: "Document Uploaded",
    value: DISPUTE_STATUS_ENUM.DOCUMENTUPLOADED,
  },
  {
    label: "Resolved",
    value: DISPUTE_STATUS_ENUM.RESOLVED,
  },
  {
    label: "Lost",
    value: DISPUTE_STATUS_ENUM.LOSTUNDERRECOVERY,
  },
  {
    label: "Reopen",
    value: DISPUTE_STATUS_ENUM.ARBITRATIONRAISED,
  },
];

export const DISPUTE_STATUS = {
  [DISPUTE_STATUS_ENUM.RAISED]: {
    id: 1,
    title: "Raised",
    variant: "butterscotch_yellow",
    icon: <PendingClockIcon />,
  },
  [DISPUTE_STATUS_ENUM.ACCEPTED]: {
    id: 2,
    title: "Accepted",
    variant: "fine_pine",
    icon: null,
  },
  [DISPUTE_STATUS_ENUM.DOCUMENTUPLOADED]: {
    id: 3,
    title: "Document Uploaded",
    variant: "fine_pine",
    icon: null,
  },
  [DISPUTE_STATUS_ENUM.RESOLVED]: {
    id: 4,
    title: "Resolved",
    variant: "fine_pine",
    icon: null,
  },
  [DISPUTE_STATUS_ENUM.LOSTUNDERRECOVERY]: {
    id: 5,
    title: "Lost",
    variant: "danger",
    icon: <CancelRoundedIcon className="mui_icon" />,
  },
  [DISPUTE_STATUS_ENUM.LOSTRECOVERED]: {
    id: 5,
    title: "Lost",
    variant: "danger",
    icon: <CancelRoundedIcon className="mui_icon" />,
  },
  [DISPUTE_STATUS_ENUM.ARBITRATIONRAISED]: {
    id: 6,
    title: "Reopen",
    variant: "butterscotch_yellow",
    icon: <PendingClockIcon />,
  },
};

export const ACTION_ELIGIBLE_STATUSES = [
  DISPUTE_STATUS_ENUM.RAISED,
  DISPUTE_STATUS_ENUM.ARBITRATIONRAISED,
];

export const emptyStateProps = {
  page_title: "Dispute History",
  content_title: "No disputes so far",
  empty_list_icon: EmptyListIcon,
  alt: "no transactions",
  preview_image: constants.preview_all_transactions,
  children: "Once a dispute is raised, it will be listed here.",
};

export const FIELD_DATA = {
  customer_name: "customer_name",
  customer_phone: "customer_phone",
  customer_phone_number: "customer_phone",
  customer_email: "customer_email",
  listing_title: "listing_title",
  listing_type: "listing_type",
  transaction_amount: "transaction_amount",
  transaction_id: "transaction_uuid",
  transaction_date: "transaction_date",
  dispute_reason: "dispute_reason",
  raised_date: "raised_date",
  raised_date_filter: "created_at",
  dispute_due_date: "dispute_due_date",
  resolved_date: "resolved_date",
  resolved_date_filter: "resolved_at",
  documents: "documents",
  status: "status",
  action: "action",
};
export const FORM_DATA = {
  customer_name: "Customer Name",
  customer_phone: "Phone",
  customer_email: "Email Id",
  listing_title: "Offering Name",
  listing_type: "Offering Type",
  transaction_amount: "Transaction Amount",
  transaction_id: "Transaction ID",
  transaction_date: "Transaction Date",
  dispute_reason: "Dispute Reason",
  dispute_raised_date: "Dispute Raised Date",
  dispute_due_date: "Document Upload Deadline",
  dispute_resolved_date: "Dispute Resolved Date",
  dispute_documents: "Dispute Documents",
  dispute_status: "Dispute Status",
  action: "Action",
};

export const DAY_OFFSETS = {
  TOMORROW: 1,
  YESTERDAY: -1,
  WITHIN_WEEK: 7,
};

export const HEADER_NOTE = {
  dispute_documents_links:
    "These document link(s) that you have uploaded to resolve the dispute",
  dispute_title: "Dispute History",
  dispute_sub_heading: `Dispute (also known as Chargeback) as the name suggests is a disagreement against a particular transaction initiated by the end consumer, who has paid for the product or service. End customer raises a dispute with his/her issuing bank. It is a service provided by the issuing bank/ card network to protect customers from unauthorized and fraudulent transactions.`,
  dispute_due_date:
    "Failure to upload the required document by the given date will result in the dispute being closed.",
};
